<template>
  <span :class="`sprite -${id} ${classes}`">
    <svg
      :viewBox="viewBox"
      class="fill-current transition duration-200 ease-in-out"
    >
      <use :xlink:href="`#${id}`" />
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    viewBox: {
      type: String,
      default: '0 0 1 1',
    },
    classes: {
      type: String,
      default: '',
    },
  },
};
</script>
